var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentPr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190.5mm",
    height: "231.24583mm",
    viewBox: "0 0 190.5 231.24583",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 720,
    height: 874,
    id: "rect824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 733.755,
    y1: 732.88898,
    x2: -13.7545,
    y2: 141.11099,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill1",
    gradientTransform: "matrix(0.26458333,0,0,0.26458333,118.21875,94.633094)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6C1863",
    id: "stop827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9D2791",
    id: "stop829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB31AD",
    id: "stop831"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect834"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect837"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect840"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 720,
    height: 874,
    id: "rect1121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 733.755,
    y1: 732.88898,
    x2: -13.7545,
    y2: 141.11099,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill1-4",
    gradientTransform: "matrix(0.26458333,0,0,0.26458333,320.68269,215.32508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4F429B",
    id: "stop1124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6A5CB6",
    id: "stop1126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#948ACA",
    id: "stop1128"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect1131"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect1134"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect1137"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 720,
    height: 874,
    id: "rect1435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 733.755,
    y1: 732.88898,
    x2: -13.7545,
    y2: 141.11099,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill1-0",
    gradientTransform: "matrix(0.26458333,0,0,0.26458333,403.5613,279.25866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19666C",
    id: "stop1438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#28959D",
    id: "stop1440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32B2BB",
    id: "stop1442"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect1445"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect1448"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect1451"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-403.5613,-279.25866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 403.5613,283.00706 c 0,-2.07018 1.67822,-3.7484 3.7484,-3.7484 h 37.21783 c 2.0701,0 3.74835,1.67822 3.74835,3.7484 v 48.59491 c 0,2.0701 -1.67825,3.74836 -3.74835,3.74836 H 407.3097 c -2.07018,0 -3.7484,-1.67826 -3.7484,-3.74836 z",
    fill: "#382463",
    fillRule: "evenodd",
    id: "path1456",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 498.8113,466.62943 c 0,-2.21721 1.79731,-4.01452 4.01452,-4.01452 h 87.22095 c 2.21721,0 4.01453,1.79731 4.01453,4.01452 v 39.86054 c 0,2.21721 -1.79732,4.01452 -4.01453,4.01452 h -87.22095 c -2.21721,0 -4.01452,-1.79731 -4.01452,-4.01452 z",
    fill: "#382463",
    fillRule: "evenodd",
    id: "path1458",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 418.37797,296.8207 c 0,-1.95461 1.58451,-3.53912 3.53912,-3.53912 h 153.78847 c 1.95448,0 3.53907,1.58451 3.53907,3.53912 v 196.12181 c 0,1.95447 -1.58459,3.53906 -3.53907,3.53906 H 421.91709 c -1.95461,0 -3.53912,-1.58459 -3.53912,-3.53906 z",
    fill: "url(#fill1)",
    fillRule: "evenodd",
    id: "path1460",
    style: {
      fill: "url(#fill1-0)",
      strokeWidth: 0.264583
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2-6)",
    id: "g1474",
    transform: "matrix(0.26458333,0,0,0.26458333,403.5613,279.25866)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3-5)",
    id: "g1472"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4-5)",
    id: "g1470"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.6047,33.3544 C 72.0389,22.5441 62.1673,14.8961 50.5591,13.1758 c -0.24,-0.0361 -0.4823,-0.0543 -0.7249,-0.0543 -2.7074,0.0033 -4.9012,2.1973 -4.9047,4.9047 v 7.9731 c 0,2.2919 1.8578,4.1497 4.1497,4.1497 2.2919,0 4.1497,-1.8578 4.1497,-4.1497 v -3.3282 c 10e-4,-0.1558 0.126,-0.2826 0.2818,-0.2859 0.0294,0 0.0586,0.0047 0.0866,0.0141 13.28,4.4068 20.4733,18.7448 16.0665,32.0247 -3.0928,9.3202 -11.2929,16.0138 -21.0437,17.1773 -2.2784,0.2467 -3.9255,2.2939 -3.6787,4.5723 0.2289,2.1135 2.0181,3.7124 4.1438,3.7029 0.1641,6e-4 0.3282,-0.0088 0.4913,-0.0282 C 68.0289,77.6555 81.21,60.9191 79.0172,42.4667 78.6447,39.331 77.8325,36.2636 76.6047,33.3544 Z",
    fill: "#ffffff",
    transform: "matrix(1,0,0,1.01075,148,112)",
    id: "path1462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89.396,28.5101 C 79.4499,4.82098 52.1833,-6.31995 28.4942,3.62611 17.3385,8.30988 8.44659,17.1556 3.7047,28.2866 -6.28299,51.9521 4.80513,79.2334 28.4706,89.2212 52.0353,99.1661 79.2083,88.2175 89.2953,64.7134 94.2054,53.1522 94.2417,40.0985 89.396,28.5101 Z M 83.7846,46.5966 C 83.7054,67.1249 66.9999,83.702 46.4716,83.6229 25.9436,83.5438 9.36636,66.8382 9.44551,46.3099 9.52468,25.7819 26.2303,9.2046 46.7583,9.28377 c 14.9229,0.05757 28.3643,9.03413 34.135,22.79613 1.928,4.5956 2.9086,9.5331 2.8832,14.5167 z",
    fill: "#ffffff",
    transform: "matrix(1,0,0,1.01075,148,112)",
    id: "path1464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.0537,38.6416 C 61.8304,31.0089 54.3485,26.0495 46.0631,26.0537 v 0 c -11.3855,8e-4 -20.6146,9.2315 -20.6138,20.617 8e-4,9.8143 6.9201,18.2672 16.5406,20.2072 1.856,0.3591 3.6516,-0.8541 4.0108,-2.7101 0.0418,-0.2163 0.0628,-0.4361 0.0624,-0.6564 v -0.0886 c -0.0075,-1.629 -1.1622,-3.027 -2.7604,-3.3423 -7.4148,-1.482 -12.2243,-8.6943 -10.7422,-16.1092 1.2849,-6.4288 6.9467,-11.0444 13.5026,-11.0075 v 0 c 6.5009,0.0016 12.1063,4.57 13.4195,10.9369 0.3122,1.5984 1.7075,2.7553 3.3362,2.7664 h 0.0825 c 1.8904,0.0032 3.4255,-1.5264 3.4289,-3.4168 4e-4,-0.2202 -0.0205,-0.4401 -0.0624,-0.6563 -0.2696,-1.3553 -0.6765,-2.6795 -1.2141,-3.9524 z",
    fill: "#ffffff",
    transform: "matrix(1,0,0,1.01075,148,112)",
    id: "path1466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.6242,50.9054 c -2.4337,-0.3725 -4.1044,-2.6473 -3.7321,-5.0809 0.3572,-2.3324 2.4698,-3.9826 4.8193,-3.7641 0.324,0.0298 0.6439,0.094 0.9544,0.1913 0.2013,0.0674 0.3098,0.2855 0.2424,0.4868 -0.0256,0.0763 -0.0745,0.1426 -0.1397,0.1897 l -0.7208,0.5255 c -1.1596,0.8474 -1.4129,2.4743 -0.5658,3.6342 v 0 c 0.8432,1.1575 2.4638,1.4151 3.6241,0.5759 l 2.9698,-2.1443 c 1.6001,-1.1555 1.9605,-3.3894 0.805,-4.9897 -0.0461,-0.0638 -0.0942,-0.1262 -0.1446,-0.1868 -2.0847,-2.5158 -5.2991,-3.808 -8.5449,-3.4349 -3.2875,0.334 -6.1581,2.3698 -7.5604,5.3617 -2.8631,6.1611 1.0369,12.7993 7.202,13.7617 1.2795,0.2006 2.5862,0.1396 3.8416,-0.1792 1.3583,-0.3529 2.1731,-1.7402 1.8199,-3.0984 -0.0809,-0.3113 -0.2202,-0.6046 -0.4105,-0.864 l -0.0644,-0.0886 c -0.6202,-0.8331 -1.6798,-1.2124 -2.688,-0.9624 -0.5595,0.1323 -1.1393,0.1549 -1.7073,0.0665 z",
    fill: "#ffffff",
    transform: "matrix(1,0,0,1.01075,148,112)",
    id: "path1468"
  }))))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "EduBits",
    id: "text1476",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 479.18502,317.05177 v 2.40452 h 3.87773 v 2.2352 h -3.87773 v 2.60773 h 4.38573 v 2.31986 h -7.28132 V 314.7319 h 7.28132 v 2.31987 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1570"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 484.87459,321.87776 q 0,-1.45627 0.54186,-2.55693 0.5588,-1.10067 1.50706,-1.69333 0.94827,-0.59267 2.11667,-0.59267 0.93133,0 1.69333,0.38947 0.77893,0.38946 1.21919,1.04986 v -4.38572 h 2.8956 v 12.53064 h -2.8956 v -1.35466 q -0.40639,0.67733 -1.16839,1.08373 -0.74507,0.4064 -1.74413,0.4064 -1.1684,0 -2.11667,-0.59267 -0.94826,-0.6096 -1.50706,-1.71026 -0.54186,-1.1176 -0.54186,-2.57386 z m 7.07811,0.0169 q 0,-1.08373 -0.60959,-1.71026 -0.59267,-0.62654 -1.45627,-0.62654 -0.8636,0 -1.4732,0.62654 -0.59266,0.60959 -0.59266,1.69333 0,1.08373 0.59266,1.72719 0.6096,0.62653 1.4732,0.62653 0.8636,0 1.45627,-0.62653 0.60959,-0.62653 0.60959,-1.71026 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 506.27826,317.1703 v 9.44878 h -2.8956 v -1.28693 q -0.44026,0.62653 -1.20226,1.016 -0.74507,0.37253 -1.65946,0.37253 -1.08373,0 -1.91347,-0.47413 -0.82973,-0.49107 -1.28693,-1.40547 -0.4572,-0.9144 -0.4572,-2.15053 v -5.52025 h 2.87866 v 5.13079 q 0,0.94826 0.49107,1.4732 0.49107,0.52493 1.3208,0.52493 0.84666,0 1.33773,-0.52493 0.49106,-0.52494 0.49106,-1.4732 v -5.13079 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 515.5577,320.52309 q 1.03294,0.22013 1.65947,1.03293 0.62653,0.79587 0.62653,1.8288 0,1.49013 -1.04986,2.37066 -1.03294,0.8636 -2.8956,0.8636 h -5.53719 V 314.7319 h 5.35093 q 1.81186,0 2.82786,0.82973 1.03293,0.82974 1.03293,2.25213 0,1.04987 -0.5588,1.74413 -0.54187,0.69427 -1.45627,0.9652 z m -4.30105,-0.98213 h 1.89653 q 0.71119,0 1.08373,-0.3048 0.38946,-0.32173 0.38946,-0.93133 0,-0.6096 -0.38946,-0.93133 -0.37254,-0.32173 -1.08373,-0.32173 h -1.89653 z m 2.13359,4.74132 q 0.72813,0 1.1176,-0.32173 0.4064,-0.33866 0.4064,-0.9652 0,-0.62653 -0.42333,-0.98213 -0.4064,-0.3556 -1.13453,-0.3556 h -2.09973 v 2.62466 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 520.97634,316.18817 q -0.762,0 -1.25307,-0.44027 -0.47413,-0.4572 -0.47413,-1.1176 0,-0.67733 0.47413,-1.11759 0.49107,-0.4572 1.25307,-0.4572 0.74506,0 1.21919,0.4572 0.49107,0.44026 0.49107,1.11759 0,0.6604 -0.49107,1.1176 -0.47413,0.44027 -1.21919,0.44027 z m 1.43933,0.98213 v 9.44878 h -2.8956 v -9.44878 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 529.78162,324.16375 v 2.45533 h -1.4732 q -1.57479,0 -2.45532,-0.762 -0.88054,-0.77893 -0.88054,-2.52306 v -3.75919 h -1.15146 v -2.40453 h 1.15146 v -2.30293 h 2.8956 v 2.30293 h 1.89653 v 2.40453 h -1.89653 v 3.79306 q 0,0.42333 0.2032,0.60959 0.2032,0.18627 0.67733,0.18627 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 535.23411,326.75455 q -1.23613,0 -2.20133,-0.42334 -0.96519,-0.42333 -1.52399,-1.15146 -0.5588,-0.74507 -0.62654,-1.65946 h 2.86173 q 0.0508,0.49106 0.4572,0.79586 0.4064,0.3048 0.99907,0.3048 0.54186,0 0.82973,-0.2032 0.3048,-0.22013 0.3048,-0.5588 0,-0.4064 -0.42334,-0.59266 -0.42333,-0.2032 -1.37159,-0.44027 -1.016,-0.23707 -1.69333,-0.49107 -0.67733,-0.27093 -1.1684,-0.82973 -0.49107,-0.57573 -0.49107,-1.54093 0,-0.8128 0.44027,-1.47319 0.4572,-0.67734 1.3208,-1.0668 0.88053,-0.38947 2.08279,-0.38947 1.778,0 2.794,0.88053 1.03293,0.88053 1.18533,2.3368 h -2.67546 q -0.0677,-0.49107 -0.44027,-0.77893 -0.3556,-0.28787 -0.94826,-0.28787 -0.508,0 -0.77893,0.2032 -0.27094,0.18627 -0.27094,0.52493 0,0.4064 0.42333,0.6096 0.44027,0.2032 1.35467,0.4064 1.04986,0.27093 1.71026,0.54187 0.6604,0.254 1.15147,0.84666 0.508,0.57573 0.52493,1.55786 0,0.82974 -0.47413,1.49014 -0.4572,0.64346 -1.33773,1.01599 -0.8636,0.37254 -2.01507,0.37254 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1582"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 431.47484,345.80137 H 566.26417",
    stroke: "#ffffff",
    strokeWidth: 0.705556,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    id: "path1478"
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "EduBitsPress Release",
    id: "text1482",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 470.4768,370.4976 v 2.40452 h 3.87773 v 2.2352 h -3.87773 v 2.60773 h 4.38573 v 2.31986 h -7.28132 v -11.88718 h 7.28132 v 2.31987 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 476.16636,375.32359 q 0,-1.45627 0.54187,-2.55693 0.5588,-1.10067 1.50706,-1.69333 0.94827,-0.59267 2.11667,-0.59267 0.93133,0 1.69333,0.38947 0.77893,0.38946 1.21919,1.04986 v -4.38572 h 2.8956 v 12.53064 h -2.8956 v -1.35466 q -0.4064,0.67733 -1.16839,1.08373 -0.74507,0.4064 -1.74413,0.4064 -1.1684,0 -2.11667,-0.59267 -0.94826,-0.6096 -1.50706,-1.71026 -0.54187,-1.1176 -0.54187,-2.57386 z m 7.07812,0.0169 q 0,-1.08373 -0.6096,-1.71026 -0.59266,-0.62654 -1.45626,-0.62654 -0.8636,0 -1.4732,0.62654 -0.59266,0.6096 -0.59266,1.69333 0,1.08373 0.59266,1.72719 0.6096,0.62654 1.4732,0.62654 0.8636,0 1.45626,-0.62654 0.6096,-0.62653 0.6096,-1.71026 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 497.57004,370.61613 v 9.44878 h -2.8956 v -1.28693 q -0.44026,0.62653 -1.20226,1.016 -0.74507,0.37253 -1.65946,0.37253 -1.08374,0 -1.91347,-0.47413 -0.82973,-0.49107 -1.28693,-1.40547 -0.4572,-0.91439 -0.4572,-2.15052 v -5.52026 h 2.87866 v 5.13079 q 0,0.94826 0.49107,1.4732 0.49106,0.52493 1.3208,0.52493 0.84666,0 1.33773,-0.52493 0.49106,-0.52494 0.49106,-1.4732 v -5.13079 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 506.84948,373.96892 q 1.03293,0.22014 1.65947,1.03293 0.62653,0.79587 0.62653,1.8288 0,1.49013 -1.04987,2.37066 -1.03293,0.8636 -2.89559,0.8636 h -5.53719 v -11.88718 h 5.35092 q 1.81187,0 2.82786,0.82974 1.03294,0.82973 1.03294,2.25212 0,1.04987 -0.5588,1.74413 -0.54187,0.69427 -1.45627,0.9652 z m -4.30105,-0.98213 h 1.89652 q 0.7112,0 1.08374,-0.3048 0.38946,-0.32173 0.38946,-0.93133 0,-0.6096 -0.38946,-0.93133 -0.37254,-0.32173 -1.08374,-0.32173 h -1.89652 z m 2.13359,4.74133 q 0.72813,0 1.1176,-0.32174 0.4064,-0.33866 0.4064,-0.9652 0,-0.62653 -0.42333,-0.98213 -0.4064,-0.3556 -1.13454,-0.3556 h -2.09972 v 2.62467 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 512.26811,369.634 q -0.76199,0 -1.25306,-0.44027 -0.47413,-0.4572 -0.47413,-1.1176 0,-0.67733 0.47413,-1.11759 0.49107,-0.4572 1.25306,-0.4572 0.74507,0 1.2192,0.4572 0.49107,0.44026 0.49107,1.11759 0,0.6604 -0.49107,1.1176 -0.47413,0.44027 -1.2192,0.44027 z m 1.43933,0.98213 v 9.44878 h -2.89559 v -9.44878 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 521.0734,377.60958 v 2.45533 h -1.4732 q -1.57479,0 -2.45533,-0.762 -0.88053,-0.77893 -0.88053,-2.52306 v -3.75919 h -1.15146 v -2.40453 h 1.15146 v -2.30293 h 2.8956 v 2.30293 h 1.89653 v 2.40453 h -1.89653 v 3.79306 q 0,0.42333 0.2032,0.6096 0.2032,0.18626 0.67733,0.18626 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 526.52589,380.20038 q -1.23613,0 -2.20133,-0.42334 -0.9652,-0.42333 -1.52399,-1.15146 -0.5588,-0.74506 -0.62654,-1.65946 h 2.86173 q 0.0508,0.49106 0.4572,0.79586 0.4064,0.3048 0.99906,0.3048 0.54187,0 0.82974,-0.2032 0.3048,-0.22013 0.3048,-0.5588 0,-0.4064 -0.42334,-0.59266 -0.42333,-0.2032 -1.37159,-0.44027 -1.016,-0.23706 -1.69333,-0.49106 -0.67734,-0.27094 -1.1684,-0.82974 -0.49107,-0.57573 -0.49107,-1.54093 0,-0.81279 0.44027,-1.47319 0.4572,-0.67734 1.3208,-1.0668 0.88053,-0.38947 2.08279,-0.38947 1.778,0 2.794,0.88053 1.03293,0.88054 1.18533,2.3368 h -2.67546 q -0.0677,-0.49107 -0.44027,-0.77893 -0.3556,-0.28787 -0.94826,-0.28787 -0.508,0 -0.77894,0.2032 -0.27093,0.18627 -0.27093,0.52493 0,0.4064 0.42333,0.6096 0.44027,0.2032 1.35467,0.4064 1.04986,0.27093 1.71026,0.54187 0.6604,0.254 1.15147,0.84666 0.50799,0.57573 0.52493,1.55787 0,0.82973 -0.47414,1.49013 -0.45719,0.64346 -1.33773,1.01599 -0.86359,0.37254 -2.01506,0.37254 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path1543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 449.41146,392.37758 q 0,1.03294 -0.47414,1.89653 -0.47413,0.84667 -1.45626,1.3716 -0.98213,0.52493 -2.43839,0.52493 h -1.79493 v 4.2672 h -2.8956 v -11.88718 h 4.69053 q 1.42239,0 2.40452,0.49106 0.98214,0.49107 1.4732,1.35467 0.49107,0.8636 0.49107,1.98119 z m -4.58893,1.49014 q 0.82973,0 1.23613,-0.38947 0.4064,-0.38947 0.4064,-1.10067 0,-0.71119 -0.4064,-1.10066 -0.4064,-0.38947 -1.23613,-0.38947 h -1.57479 v 2.98027 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 453.81409,392.56385 q 0.508,-0.77893 1.27,-1.2192 0.762,-0.4572 1.69333,-0.4572 v 3.06493 h -0.79587 q -1.08373,0 -1.62559,0.47413 -0.54187,0.4572 -0.54187,1.6256 v 4.38573 h -2.89559 v -9.44879 h 2.89559 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 467.07286,395.56105 q 0,0.40639 -0.0508,0.84666 h -6.55319 q 0.0677,0.88053 0.5588,1.35466 0.508,0.4572 1.23613,0.4572 1.08373,0 1.50706,-0.91439 h 3.08186 q -0.23706,0.93133 -0.86359,1.67639 -0.6096,0.74507 -1.54093,1.1684 -0.93134,0.42333 -2.0828,0.42333 -1.38853,0 -2.47226,-0.59266 -1.08373,-0.59267 -1.69333,-1.69333 -0.6096,-1.10067 -0.6096,-2.57387 0,-1.47319 0.59267,-2.57386 0.60959,-1.10066 1.69333,-1.69333 1.08373,-0.59266 2.48919,-0.59266 1.3716,0 2.4384,0.57573 1.06679,0.57573 1.65946,1.64253 0.6096,1.0668 0.6096,2.4892 z m -2.96333,-0.762 q 0,-0.74507 -0.508,-1.18533 -0.508,-0.44027 -1.27,-0.44027 -0.72813,0 -1.23613,0.42333 -0.49106,0.42333 -0.6096,1.20227 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1549"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 472.4407,400.5733 q -1.23613,0 -2.20133,-0.42333 -0.9652,-0.42333 -1.524,-1.15146 -0.5588,-0.74507 -0.62653,-1.65947 h 2.86173 q 0.0508,0.49107 0.4572,0.79587 0.4064,0.3048 0.99906,0.3048 0.54187,0 0.82973,-0.2032 0.3048,-0.22014 0.3048,-0.5588 0,-0.4064 -0.42333,-0.59267 -0.42333,-0.2032 -1.3716,-0.44026 -1.01599,-0.23707 -1.69333,-0.49107 -0.67733,-0.27093 -1.16839,-0.82973 -0.49107,-0.57573 -0.49107,-1.54093 0,-0.8128 0.44027,-1.4732 0.4572,-0.67733 1.32079,-1.0668 0.88054,-0.38946 2.0828,-0.38946 1.778,0 2.79399,0.88053 1.03294,0.88053 1.18534,2.33679 h -2.67547 q -0.0677,-0.49106 -0.44026,-0.77893 -0.3556,-0.28786 -0.94827,-0.28786 -0.508,0 -0.77893,0.2032 -0.27093,0.18626 -0.27093,0.52493 0,0.4064 0.42333,0.6096 0.44027,0.2032 1.35467,0.4064 1.04986,0.27093 1.71026,0.54186 0.6604,0.254 1.15146,0.84667 0.508,0.57573 0.52494,1.55786 0,0.82973 -0.47414,1.49013 -0.4572,0.64347 -1.33773,1.016 -0.8636,0.37253 -2.01506,0.37253 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 481.88946,400.5733 q -1.23613,0 -2.20133,-0.42333 -0.9652,-0.42333 -1.524,-1.15146 -0.5588,-0.74507 -0.62653,-1.65947 h 2.86173 q 0.0508,0.49107 0.4572,0.79587 0.4064,0.3048 0.99906,0.3048 0.54187,0 0.82973,-0.2032 0.3048,-0.22014 0.3048,-0.5588 0,-0.4064 -0.42333,-0.59267 -0.42333,-0.2032 -1.3716,-0.44026 -1.01599,-0.23707 -1.69333,-0.49107 -0.67733,-0.27093 -1.16839,-0.82973 -0.49107,-0.57573 -0.49107,-1.54093 0,-0.8128 0.44027,-1.4732 0.4572,-0.67733 1.32079,-1.0668 0.88053,-0.38946 2.0828,-0.38946 1.778,0 2.79399,0.88053 1.03294,0.88053 1.18533,2.33679 h -2.67546 q -0.0677,-0.49106 -0.44026,-0.77893 -0.3556,-0.28786 -0.94827,-0.28786 -0.508,0 -0.77893,0.2032 -0.27093,0.18626 -0.27093,0.52493 0,0.4064 0.42333,0.6096 0.44027,0.2032 1.35466,0.4064 1.04987,0.27093 1.71027,0.54186 0.6604,0.254 1.15146,0.84667 0.508,0.57573 0.52493,1.55786 0,0.82973 -0.47413,1.49013 -0.4572,0.64347 -1.33773,1.016 -0.8636,0.37253 -2.01506,0.37253 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 497.14634,400.43784 -2.47226,-4.48733 h -0.69427 v 4.48733 h -2.89559 v -11.88718 h 4.85985 q 1.40547,0 2.3876,0.49106 0.99906,0.49107 1.49013,1.35467 0.49106,0.84666 0.49106,1.89653 0,1.18533 -0.67733,2.11666 -0.6604,0.93133 -1.96426,1.3208 l 2.74319,4.70746 z m -3.16653,-6.53626 h 1.79493 q 0.79587,0 1.18533,-0.38946 0.4064,-0.38947 0.4064,-1.10067 0,-0.67733 -0.4064,-1.0668 -0.38946,-0.38946 -1.18533,-0.38946 h -1.79493 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 511.03162,395.56105 q 0,0.40639 -0.0508,0.84666 h -6.55319 q 0.0677,0.88053 0.5588,1.35466 0.508,0.4572 1.23613,0.4572 1.08373,0 1.50707,-0.91439 h 3.08186 q -0.23707,0.93133 -0.8636,1.67639 -0.6096,0.74507 -1.54093,1.1684 -0.93133,0.42333 -2.0828,0.42333 -1.38853,0 -2.47226,-0.59266 -1.08373,-0.59267 -1.69333,-1.69333 -0.6096,-1.10067 -0.6096,-2.57387 0,-1.47319 0.59267,-2.57386 0.6096,-1.10066 1.69333,-1.69333 1.08373,-0.59266 2.48919,-0.59266 1.3716,0 2.4384,0.57573 1.0668,0.57573 1.65946,1.64253 0.6096,1.0668 0.6096,2.4892 z m -2.96333,-0.762 q 0,-0.74507 -0.508,-1.18533 -0.50799,-0.44027 -1.26999,-0.44027 -0.72813,0 -1.23613,0.42333 -0.49107,0.42333 -0.6096,1.20227 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1557"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 515.4512,387.90719 v 12.53065 h -2.8956 v -12.53065 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 526.45781,395.56105 q 0,0.40639 -0.0508,0.84666 h -6.55319 q 0.0677,0.88053 0.5588,1.35466 0.508,0.4572 1.23613,0.4572 1.08373,0 1.50707,-0.91439 h 3.08186 q -0.23707,0.93133 -0.8636,1.67639 -0.6096,0.74507 -1.54093,1.1684 -0.93133,0.42333 -2.0828,0.42333 -1.38853,0 -2.47226,-0.59266 -1.08373,-0.59267 -1.69333,-1.69333 -0.6096,-1.10067 -0.6096,-2.57387 0,-1.47319 0.59267,-2.57386 0.6096,-1.10066 1.69333,-1.69333 1.08373,-0.59266 2.48919,-0.59266 1.3716,0 2.4384,0.57573 1.0668,0.57573 1.65946,1.64253 0.6096,1.0668 0.6096,2.4892 z m -2.96333,-0.762 q 0,-0.74507 -0.508,-1.18533 -0.508,-0.44027 -1.26999,-0.44027 -0.72814,0 -1.23613,0.42333 -0.49107,0.42333 -0.6096,1.20227 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 527.40606,395.69651 q 0,-1.45626 0.54187,-2.55693 0.5588,-1.10066 1.50706,-1.69333 0.94827,-0.59266 2.11666,-0.59266 0.99907,0 1.74413,0.4064 0.762,0.4064 1.1684,1.06679 v -1.33773 h 2.8956 v 9.44879 h -2.8956 v -1.33774 q -0.42333,0.6604 -1.18533,1.0668 -0.74506,0.4064 -1.74413,0.4064 -1.15146,0 -2.09973,-0.59266 -0.94826,-0.6096 -1.50706,-1.71027 -0.54187,-1.11759 -0.54187,-2.57386 z m 7.07812,0.0169 q 0,-1.08373 -0.6096,-1.71026 -0.59266,-0.62653 -1.45626,-0.62653 -0.8636,0 -1.4732,0.62653 -0.59266,0.6096 -0.59266,1.69333 0,1.08373 0.59266,1.7272 0.6096,0.62653 1.4732,0.62653 0.8636,0 1.45626,-0.62653 0.6096,-0.62653 0.6096,-1.71027 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 543.32335,400.5733 q -1.23613,0 -2.20133,-0.42333 -0.9652,-0.42333 -1.524,-1.15146 -0.55879,-0.74507 -0.62653,-1.65947 h 2.86173 q 0.0508,0.49107 0.4572,0.79587 0.4064,0.3048 0.99906,0.3048 0.54187,0 0.82974,-0.2032 0.30479,-0.22014 0.30479,-0.5588 0,-0.4064 -0.42333,-0.59267 -0.42333,-0.2032 -1.3716,-0.44026 -1.01599,-0.23707 -1.69333,-0.49107 -0.67733,-0.27093 -1.16839,-0.82973 -0.49107,-0.57573 -0.49107,-1.54093 0,-0.8128 0.44027,-1.4732 0.4572,-0.67733 1.32079,-1.0668 0.88054,-0.38946 2.0828,-0.38946 1.778,0 2.794,0.88053 1.03293,0.88053 1.18533,2.33679 h -2.67547 q -0.0677,-0.49106 -0.44026,-0.77893 -0.3556,-0.28786 -0.94827,-0.28786 -0.50799,0 -0.77893,0.2032 -0.27093,0.18626 -0.27093,0.52493 0,0.4064 0.42333,0.6096 0.44027,0.2032 1.35467,0.4064 1.04986,0.27093 1.71026,0.54186 0.6604,0.254 1.15146,0.84667 0.508,0.57573 0.52494,1.55786 0,0.82973 -0.47414,1.49013 -0.4572,0.64347 -1.33773,1.016 -0.8636,0.37253 -2.01506,0.37253 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 557.83516,395.56105 q 0,0.40639 -0.0508,0.84666 h -6.55319 q 0.0677,0.88053 0.5588,1.35466 0.508,0.4572 1.23613,0.4572 1.08373,0 1.50707,-0.91439 h 3.08186 q -0.23707,0.93133 -0.8636,1.67639 -0.6096,0.74507 -1.54093,1.1684 -0.93133,0.42333 -2.0828,0.42333 -1.38853,0 -2.47226,-0.59266 -1.08373,-0.59267 -1.69333,-1.69333 -0.6096,-1.10067 -0.6096,-2.57387 0,-1.47319 0.59267,-2.57386 0.6096,-1.10066 1.69333,-1.69333 1.08373,-0.59266 2.48919,-0.59266 1.3716,0 2.4384,0.57573 1.0668,0.57573 1.65946,1.64253 0.6096,1.0668 0.6096,2.4892 z m -2.96333,-0.762 q 0,-0.74507 -0.508,-1.18533 -0.508,-0.44027 -1.26999,-0.44027 -0.72814,0 -1.23613,0.42333 -0.49107,0.42333 -0.6096,1.20227 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path1567"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPr);
export default __webpack_public_path__ + "static/media/document-pr.2c4d03ceab979d346e1cb037fa97d61e.svg";
export { ForwardRef as ReactComponent };